import { OperationTypes } from '@/components/OperationTypes'
import React from 'react'
interface IProps {
  operationType: string
  onChangeOperationType: (value: string) => void
}
export const OperationTypesMainFilters = ({
  operationType,
  onChangeOperationType
}: IProps) => {
  return (
    <div style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
    className="flex items-center gap-4 p-4 rounded-xl border border-surface-strokes shadow-[0px_3px_34px_-2px_rgba(34,34,34,0.20)] bg-white overflow-y-auto">
      <OperationTypes
        operationType={operationType}
        onChangeOperationType={onChangeOperationType}
      />
    </div>
  )
}
